<!--
  Note on $any(...) casts:
  ng-select v18 uses Angular signals (input(), model()) internally and its
  generated .d.ts types these optional inputs as non-nullable. At runtime
  they accept undefined just fine, but Angular's strict template type
  checker rejects passing `string | undefined` etc. $any() is Angular's
  documented escape hatch for exactly this scenario — runtime behavior is
  identical, only the strict template type check is bypassed.
-->
<ng-select
  [items]="items"
  [bindLabel]="bindLabel"
  [bindValue]="$any(bindValue)"
  [multiple]="multiple"
  [searchable]="searchable"
  [clearable]="clearable"
  [placeholder]="placeholder"
  [loading]="loading"
  [virtualScroll]="virtualScroll"
  [disabled]="disabled"
  [appendTo]="$any(appendTo)"
  [typeahead]="$any(typeahead)"
  [searchFn]="$any(searchFn)"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  (change)="change.emit($event)"
  (search)="search.emit($event)"
  (clear)="clear.emit()"
  (open)="open.emit()"
  (close)="close.emit()"
  class="app-search-select"
>
  <!-- Dropdown row: label left, muted meta right (design combo); override with #optionTpl -->
  <ng-template
    ng-option-tmp
    let-item="item"
    let-searchTerm="searchTerm"
    let-index="index"
  >
    <ng-container
      *ngIf="optionTpl; else defaultOption"
      [ngTemplateOutlet]="optionTpl"
      [ngTemplateOutletContext]="{
        $implicit: item,
        item: item,
        searchTerm: searchTerm,
        index: index
      }"
    >
    </ng-container>
    <ng-template #defaultOption>
      <div class="ss-row">
        <span class="ss-row__primary" [title]="primaryText(item)">{{ primaryText(item) }}</span>
        <span class="ss-row__secondary" *ngIf="secondaryText(item) as sec" [title]="sec">{{ sec }}</span>
      </div>
    </ng-template>
  </ng-template>

  <!-- Closed-box label: primary + small mono meta (e.g. vendor code) -->
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <ng-container
      *ngIf="labelTpl; else defaultLabel"
      [ngTemplateOutlet]="labelTpl"
      [ngTemplateOutletContext]="{
        $implicit: item,
        item: item,
        clear: clear
      }"
    >
    </ng-container>
    <ng-template #defaultLabel>
      <span class="ss-label">
        <span class="ss-label__t">{{ primaryText(item) }}</span>
        <span class="ss-label__m" *ngIf="labelMeta(item) as m">{{ m }}</span>
      </span>
    </ng-template>
  </ng-template>
</ng-select>
